// LICENSE_CODE ZON
'use strict'; /*jslint ts:true, react:true*/
import React, {Fragment, useContext, useEffect,
    useMemo, useState} from 'react';
import {Editor} from '../../../shared/editor/editor';
import {Settings_context} from '../settings_ctx';
import {Button} from '../../../shared/button';
import cn from 'classnames';
import styles from './access_problem_tips.module.less';

function process_html_classes(html: string, process_class_name: (
class_name: string)=>string): string
{
    return html.replace(/class\s*=\s*["']([^"']+)["']/g, (match, list)=>{
        let new_list = list.split(/\s+/).map(process_class_name).join(' ');
        return `class="${new_list}"`;
    });
}

const Lightning_svg = (props: {color?: string})=>{
    const {color = '#71BBFF'} = props;
    return <svg width="24" height="24" viewBox="0 0 24 24" fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path d="M9 22.25L10.5 14.9286L4.5 12.7321L15 1.75L13.5
        9.07143L19.5 11.2679L9 22.25Z" stroke={color} strokeWidth="1.5"
        strokeLinecap="round" strokeLinejoin="round"/>
    </svg>;
};

interface i_tip_props {
    text: string;
    icon_color: string;
}

const Tip = (props: i_tip_props)=>{
    const {theme} = useContext(Settings_context);
    const processed_text = useMemo(()=>
        process_html_classes(props.text, class_name=>
            theme[class_name] || class_name),
    [props.text, theme]);
    return <div className={styles.tip}>
      <div className={styles.svg_wrapper}>
        <Lightning_svg color={props.icon_color}/>
      </div>
      <p className={cn([theme.p3, theme.med,
        theme.color_n700, styles.tip_text])}>
        <span dangerouslySetInnerHTML={{__html: processed_text}}/>
      </p>
    </div>;
};

interface i_access_problem_tips_props {
    header: string;
    tips: i_tip_props[];
}

export const Access_problem_tips = (props: i_access_problem_tips_props)=>{
    const {theme} = useContext(Settings_context);
    const processed_header = useMemo(()=>
        process_html_classes(props.header, class_name=>
            theme[class_name] || class_name),
    [props.header, theme]);
    return <div className={cn([theme.container, styles.container])}>
      <h3 className={styles.header}><span
        dangerouslySetInnerHTML={{__html: processed_header}}/></h3>
      <div className={styles.tips_container}>
        {(props.tips || []).map((tip, i)=><Tip key={i} {...tip} />)}
      </div>
    </div>;
};

interface i_access_problem_tips_editor_props {
    value: i_access_problem_tips_props;
    on_change: (value: i_access_problem_tips_props)=>void;
}

export const Access_problem_tips_editor = (
props: i_access_problem_tips_editor_props)=>{
    const {value, on_change} = props;
    const [state, set_state] = useState<i_access_problem_tips_props>(()=>({
        header: value?.header || '',
        tips: value?.tips || [],
    }));
    const tips = state.tips || [];
    useEffect(()=>{
        set_state(c=>({...c, ...value}));
    }, [value]);
    return <Editor
      value={state}
      editors={[{key: 'header', label: 'Header', type: 'text'}]}
      on_change={v=>set_state(v)}
      on_save={()=>on_change(state)}>
      <h4>Tips: </h4>
      {tips.map((tip, i)=>
        <Fragment key={i}>
          <Editor
            title={tip.text || 'unknown'}
            key={i}
            value={tip}
            editors={[
              {key: 'text', label: 'Text', type: 'textarea'},
              {key: 'icon_color', label: 'Icon color', type: 'text'},
            ]}
            on_change={v=>{
              const items_new = [...tips];
              items_new[i] = v;
              set_state({...state, tips: items_new});
            }}>
          </Editor>
          <Button caption={'Delete Tip'} size={'xs'}
            on_click={()=>{
              set_state({...state, tips: tips
                .filter((_, index)=>index!==i)});
            }}/>
        </Fragment>
      )}
      <Button caption={'Add Tip'} size={'xs'}
        on_click={()=>{
          set_state({...state, tips: [...tips, {
            text: '',
            icon_color: '#71BBFF',
          }]});
        }}/>
    </Editor>;
};
